pageId = "page-member-calendar-events"
page = "#" + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-me').addClass('active') if $page.data('self')
  tower.initCalendarEventsSelector()
  tower.workStatus()

